import React from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DeleteSectionButton from './../DeleteSectionButton';
import LastUpdatedAt from './../LastUpdatedAt';
import {
  TextInput,
  RichTextInput,
  HookFormDirtyCheck,
} from "../../react-hook-form-inputs";

const CompetitionSchema = Yup.object().shape({
  content: Yup.object()
    .test(
      'has text',
      'Article content is required',
      value => value && value.getCurrentContent().getPlainText().replace(/\s/g, '').length > 0
    ),
    title: Yup.string()
    .required('Summary is required')
    .max(150)
});

export default function CompetitionForm({
  pitch:{competition_section={}}, pitchableType, pitchableId, updatePitchMutation
}) {
  if(competition_section === null) competition_section = {};

  const defaultValues = {
    title: competition_section.title || '',
    content: RichTextInput.createState(competition_section.content),
  }
  const methods = useForm({
    resolver: yupResolver(CompetitionSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: defaultValues
  });

  React.useEffect(() => {
      methods.setValue("title", competition_section.title || "");
      methods.setValue("content", RichTextInput.createState(competition_section.content || ""));
  }, [methods, competition_section]);

  const onSubmit = values => {
    const { title, content } = values
    updatePitchMutation.mutate({
      pitchable_type: pitchableType,
      pitchable_id: pitchableId,
      values: {
        pitch: {
          competition_section_attributes: {
            title,
            content: RichTextInput.contentForSave(content),
          }
        }
      }
    })
  }

  return(
    <div id="competitionForm">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-1">
          <div className="col-xs-12 row">
            <div className="col-lg-7">
              <label className="mb-1">Article content</label>
              <RichTextInput name="content" hideExternalPlugins={false} containerStyle={{ height: "400px"}}/>
            </div>
            <div className="col-lg-5">
              <label className="mb-1">Brief summary</label>
              <TextInput
                name="title"
                placeholder="Brief summary (max 150 chars)"
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <button type="submit"
              className="mx-auto btn btn-outline-dark rounded-0"
              disabled={methods.isSubmitting}
            >
              Save Section
            </button>
            <DeleteSectionButton pitchableType={pitchableType} pitchableId={pitchableId} sectionId={competition_section.id} sectionType="competition"/>
            <LastUpdatedAt updatedAt={ competition_section.updated_at }/>
            <HookFormDirtyCheck />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
